export const PERMISSION_CAN_CREATE_LESSON = 'can_create_lesson';
export const PERMISSION_CAN_PREVIEW_FULL = 'can_preview_full';
export const PERMISSION_CAN_PREVIEW_LIMITED = 'can_preview_limited';
export const PERMISSION_CAN_DOWNLOAD_TEACHER_GUIDE = 'can_download_teacher_guide';
export const PERMISSION_CAN_LOGIN_TO_ADMIN = 'can_login_to_admin';
export const PERMISSION_CAN_LOGIN_TO_RUBRIC = 'can_login_to_rubric';
export const PERMISSION_CAN_SEE_ROLES = 'can_see_roles';
export const PERMISSION_CAN_MANAGE_ROLES = 'can_manage_roles';
export const PERMISSION_CAN_SEE_USERS = 'can_see_users';
export const PERMISSION_CAN_SEE_COLLEAGUES = 'can_see_colleagues';
export const PERMISSION_CAN_MANAGE_USERS = 'can_manage_users';
export const PERMISSION_CAN_SEE_CHALLENGES = 'can_see_challenges';
export const PERMISSION_CAN_CREATE_CHALLENGE = 'can_create_challenge';
export const PERMISSION_CAN_MANAGE_CHALLENGES = 'can_manage_challenges';
export const PERMISSION_CAN_MANAGE_SETTINGS = 'can_manage_settings';
export const PERMISSION_CAN_SEE_ANNOUNCEMENTS = 'can_see_announcements';
export const PERMISSION_CAN_MANAGE_ANNOUNCEMENTS = 'can_manage_announcements';
export const PERMISSION_CAN_SEE_ALL_LESSONS = 'can_see_all_lessons';
export const PERMISSION_CAN_MANAGE_MY_LESSONS = 'can_manage_my_lessons';
export const PERMISSION_CAN_MANAGE_ALL_LESSONS = 'can_manage_all_lessons';
export const PERMISSION_CAN_SEE_CURRICULUMS = 'can_see_curriculums';
export const PERMISSION_CAN_MANAGE_CURRICULUMS = 'can_manage_curriculums';
export const PERMISSION_CAN_SEE_SCHOOLS = 'can_see_schools';
export const PERMISSION_CAN_CREATE_SCHOOLS = 'can_create_schools';
export const PERMISSION_CAN_MANAGE_SCHOOLS = 'can_manage_schools';
export const PERMISSION_CAN_REQUEST_STATISTICS = 'can_request_statistics';
export const PERMISSION_CAN_SEE_MY_STREAMS = 'can_see_my_streams';
export const PERMISSION_CAN_SEE_ALL_STREAMS = 'can_see_all_streams';
export const PERMISSION_CAN_MANAGE_MY_STREAMS = 'can_manage_my_streams';
export const PERMISSION_CAN_MANAGE_ALL_STREAMS = 'can_manage_all_streams';
export const PERMISSION_CAN_MANAGE_DISTRICTS = 'can_manage_districts';
export const PERMISSION_CAN_SEE_SAM = 'can_see_sam';
export const PERMISSION_CAN_SEE_PAM = 'can_see_pam';
export const PERMISSION_CAN_SEE_PERFORMANCE = 'can_see_performance';
export const PERMISSION_CAN_HAVE_MANY_SCHOOLS = 'can_have_many_schools';
export const PERMISSION_CAN_SEE_QUESTIONS = 'can_see_questions';
export const PERMISSION_CAN_MANAGE_QUESTIONS = 'can_manage_questions';
export const PERMISSION_CAN_SEE_RUBRICS = 'can_see_rubrics';
export const PERMISSION_CAN_MANAGE_RUBRICS = 'can_manage_rubrics';
export const PERMISSION_CAN_MASTER_RUBRICS = 'can_master_rubrics';
export const PERMISSION_CAN_GRADE_ALL_STUDENTS = 'can_grade_all_students';
export const PERMISSION_CAN_GRADE_OWN_STUDENTS = 'can_grade_own_students';
export const PERMISSION_CAN_SEE_DISTRICT_DASHBOARD = 'can_see_district_dashboard';
export const PERMISSION_CAN_SEE_SCHOOL_DASHBOARD = 'can_see_school_dashboard';
export const PERMISSION_CAN_SEE_CONTRACTS = 'can_see_contracts';
export const PERMISSION_CAN_MANAGE_CONTRACTS = 'can_manage_contracts';
export const PERMISSION_CAN_MASTER_CONTRACTS = 'can_master_contracts';
export const PERMISSION_CAN_SEE_ANSWER_REVIEW = 'can_see_answer_review';
export const PERMISSION_CAN_VERIFY_GRADING = 'can_verify_grading';

export const PERMISSIONS = {
    [PERMISSION_CAN_CREATE_LESSON]: 'Can create Class Code',
    [PERMISSION_CAN_PREVIEW_FULL]: 'Can preview all cards in a Challenge',
    [PERMISSION_CAN_PREVIEW_LIMITED]: 'Can preview first few cards in a Challenge',
    [PERMISSION_CAN_DOWNLOAD_TEACHER_GUIDE]: 'Can download Teacher Guide',
    [PERMISSION_CAN_LOGIN_TO_ADMIN]: 'Can Log in to Admin Dashboard',
    [PERMISSION_CAN_LOGIN_TO_RUBRIC]: 'Can Log in to GradeBook',
    [PERMISSION_CAN_SEE_ROLES]: 'Can See Roles',
    [PERMISSION_CAN_MANAGE_ROLES]: 'Can Manage Roles',
    [PERMISSION_CAN_SEE_USERS]: 'Can See Users',
    [PERMISSION_CAN_SEE_COLLEAGUES]: 'Can See Colleagues',
    [PERMISSION_CAN_MANAGE_USERS]: 'Can Manage Users',
    [PERMISSION_CAN_SEE_CHALLENGES]: 'Can see Challenges',
    [PERMISSION_CAN_CREATE_CHALLENGE]: 'Can create Challenge',
    [PERMISSION_CAN_MANAGE_CHALLENGES]: 'Can manage Challenges',
    [PERMISSION_CAN_MANAGE_SETTINGS]: 'Can manage App Settings',
    [PERMISSION_CAN_SEE_ANNOUNCEMENTS]: 'Can see Announcements',
    [PERMISSION_CAN_MANAGE_ANNOUNCEMENTS]: 'Can manage Announcements',
    [PERMISSION_CAN_SEE_ALL_LESSONS]: 'Can see all Lessons',
    [PERMISSION_CAN_MANAGE_MY_LESSONS]: 'Can manage my Lessons',
    [PERMISSION_CAN_MANAGE_ALL_LESSONS]: 'Can manage all Lessons',
    [PERMISSION_CAN_SEE_CURRICULUMS]: 'Can see Curriculums',
    [PERMISSION_CAN_MANAGE_CURRICULUMS]: 'Can manage Curriculums',
    [PERMISSION_CAN_SEE_SCHOOLS]: 'Can see Schools',
    [PERMISSION_CAN_CREATE_SCHOOLS]: 'Can create Schools',
    [PERMISSION_CAN_MANAGE_SCHOOLS]: 'Can manage Schools',
    [PERMISSION_CAN_REQUEST_STATISTICS]: 'Can request Statistics',
    [PERMISSION_CAN_SEE_MY_STREAMS]: 'Can see my Streams',
    [PERMISSION_CAN_SEE_ALL_STREAMS]: 'Can see all Streams',
    [PERMISSION_CAN_MANAGE_MY_STREAMS]: 'Can manage my Streams',
    [PERMISSION_CAN_MANAGE_ALL_STREAMS]: 'Can manage all Streams',
    [PERMISSION_CAN_MANAGE_DISTRICTS]: 'Can manage Districts',
    [PERMISSION_CAN_SEE_SAM]: 'Can see SAM',
    [PERMISSION_CAN_SEE_PAM]: 'Can see PAM',
    [PERMISSION_CAN_SEE_PERFORMANCE]: 'Can see Performance Dashboard',
    [PERMISSION_CAN_HAVE_MANY_SCHOOLS]: 'Can be assigned to multiple schools',
    [PERMISSION_CAN_SEE_QUESTIONS]: 'Can see questions',
    [PERMISSION_CAN_MANAGE_QUESTIONS]: 'Can manage questions',
    [PERMISSION_CAN_SEE_RUBRICS]: 'Can see rubrics',
    [PERMISSION_CAN_MANAGE_RUBRICS]: 'Can manage rubrics',
    [PERMISSION_CAN_MASTER_RUBRICS]: 'Can master rubrics',
    [PERMISSION_CAN_GRADE_ALL_STUDENTS]: 'Can grade all students',
    [PERMISSION_CAN_GRADE_OWN_STUDENTS]: 'Can grade own students',
    [PERMISSION_CAN_SEE_DISTRICT_DASHBOARD]: 'Can see district Dashboard',
    [PERMISSION_CAN_SEE_SCHOOL_DASHBOARD]: 'Can see School Dashboard',
    [PERMISSION_CAN_SEE_CONTRACTS]: 'Can see Contracts',
    [PERMISSION_CAN_MANAGE_CONTRACTS]: 'Can manage Contracts',
    [PERMISSION_CAN_MASTER_CONTRACTS]: 'Can master Contracts',
    [PERMISSION_CAN_SEE_ANSWER_REVIEW]: 'Can see Answer Review',
    [PERMISSION_CAN_VERIFY_GRADING]: 'Can verify grading',
};
